// Étape 11 — Page admin « Validations » : remises et paiements en 2 fois en attente
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, Input, Select, Spinner, fmtEur } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("auprea_token")}` } });
const eur = fmtEur;

const Carte = ({ v, onDone }) => {
  const [com, setCom] = useState("");
  const [val, setVal] = useState(v.remise?.valeur ?? "");
  const [typ, setTyp] = useState(v.remise?.type || "montant");
  const [err, setErr] = useState("");
  const decide = async (decision) => {
    setErr("");
    try {
      await axios.post(`${API}/admin/validations/${v.parcours_id}`, { decision, commentaire: com,
        ...(v.remise && decision === "accepter" ? { remise_valeur: Number(val), remise_type: typ } : {}) }, hdr());
      onDone();
    } catch (e) { setErr(e?.response?.data?.detail || "Erreur"); }
  };
  const f = v.fiche || {};
  return (
    <div data-testid={`validation-${v.parcours_id}`} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 18, marginBottom: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>{f.prenom} {f.nom} · {v.type_parcours}</div>
          <div style={{ fontSize: 12, color: C.mid }}>Consultant : {v.consultant || "—"} · {v.calc.lignes.length} ligne(s) · Total {eur(v.calc.total_ttc)} TTC</div>
        </div>
      </div>
      <div style={{ fontSize: 12, margin: "10px 0", lineHeight: 1.7 }}>
        {v.calc.lignes.map((l, i) => <div key={i}>• {l.nom}{l.qte > 1 ? ` × ${l.qte}` : ""} — {eur(l.ttc)}</div>)}
      </div>
      {v.remise?.statut === "en_attente" && (
        <div style={{ background: C.goldlt, padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 8 }}>
          <strong>Remise demandée :</strong> {v.remise.valeur}{v.remise.type === "pct" ? " %" : " €"} — motif : {v.remise.motif}
          <div style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "center" }}>
            <span style={{ fontSize: 12 }}>Montant accordé :</span>
            <Input type="number" value={val} onChange={(e) => setVal(e.target.value)} style={{ width: 110 }} data-testid="validation-montant" />
            <Select value={typ} onChange={(e) => setTyp(e.target.value)} style={{ width: 110 }} data-testid="validation-type"><option value="montant">€</option><option value="pct">%</option></Select>
          </div>
        </div>
      )}
      {v.deux_fois?.statut === "en_attente" && (
        <div style={{ background: C.teallt, padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 8 }}>
          <strong>Paiement en 2 fois :</strong> 50 % à la signature, 50 % à « {v.deux_fois.jalon} » — motif : {v.deux_fois.motif}
        </div>
      )}
      {err && <div style={{ color: C.red, fontSize: 12 }}>{err}</div>}
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <Input value={com} onChange={(e) => setCom(e.target.value)} placeholder="Commentaire (obligatoire en cas de refus)" data-testid="validation-commentaire" />
        <Btn variant="gold" onClick={() => decide("accepter")} data-testid="validation-accepter">Accepter</Btn>
        <Btn variant="red" onClick={() => decide("refuser")} data-testid="validation-refuser">Refuser</Btn>
      </div>
    </div>
  );
};

const Transfert = ({ l, onDone }) => {
  const [com, setCom] = useState("");
  const [err, setErr] = useState("");
  const decide = async (decision) => {
    try { await axios.post(`${API}/admin/leads/transferts/${l.id}`, { decision, commentaire: com }, hdr()); onDone(); }
    catch (e) { setErr(e?.response?.data?.detail || "Erreur"); }
  };
  return (
    <div data-testid={`transfert-${l.id}`} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderLeft: `3px solid ${C.gold}`, borderRadius: 12, padding: 16, marginBottom: 10 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>Transfert de lead : {l.prospect} · {l.statut_label}</div>
      <div style={{ fontSize: 12, color: C.mid, margin: "4px 0 10px" }}>De <strong>{l.transfert.de_nom}</strong> vers <strong>{l.transfert.vers_nom}</strong> — motif : {l.transfert.motif}</div>
      {err && <div style={{ color: C.red, fontSize: 12 }}>{err}</div>}
      <div style={{ display: "flex", gap: 8 }}>
        <Input value={com} onChange={(e) => setCom(e.target.value)} placeholder="Commentaire (facultatif)" data-testid="transfert-commentaire" />
        <Btn variant="gold" onClick={() => decide("accepter")} data-testid={`transfert-accepter-${l.id}`}>Valider</Btn>
        <Btn variant="red" onClick={() => decide("refuser")} data-testid={`transfert-refuser-${l.id}`}>Refuser</Btn>
      </div>
    </div>
  );
};

export default function ValidationsAdmin() {
  const [items, setItems] = useState(null);
  const [transferts, setTransferts] = useState([]);
  const load = () => {
    axios.get(`${API}/admin/validations`, hdr()).then(r => setItems(r.data));
    axios.get(`${API}/admin/leads/transferts`, hdr()).then(r => setTransferts(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  if (!items) return <Spinner />;
  return (
    <div data-testid="validations-page">
      <div style={{ fontSize: 12, color: C.mid, marginBottom: 14 }}>Remises, paiements en 2 fois et transferts de leads demandés par les consultants. Chaque décision est tracée et notifiée au consultant.</div>
      {transferts.map(l => <Transfert key={l.id} l={l} onDone={load} />)}
      {!items.length && !transferts.length && <div style={{ background: "#fff", border: `.5px dashed ${C.border}`, padding: 40, textAlign: "center", color: C.muted, borderRadius: 10 }} data-testid="validations-vide">Aucune demande en attente</div>}
      {items.map(v => <Carte key={v.parcours_id} v={v} onDone={load} />)}
    </div>
  );
}
